module.exports = __webpack_public_path__ + "img/2.151ea920.png";